/*
Monotype Foundry Platform API
Version 1.0.0

Definition: QuarterlyReportsPresignedUrlRequest

Properties:
  items: array (required)
*/

var QuarterlyReportsPresignedUrlRequest = (function () {
  function validateQuarterlyReportsPresignedUrlRequest (arg) {
    // Validate items
    if (!arg.items) {
      throw new Error('QuarterlyReportsPresignedUrlRequest.items: Missing property')
    }
    if (arg.items && !(Array.isArray(arg.items))) {
      throw new Error('QuarterlyReportsPresignedUrlRequest.items: Wrong type: Got \'' + (typeof arg.items) + '\', but expected: \'array\'')
    }
  }
  function buildQuarterlyReportsPresignedUrlRequest (arg) {
    var QuarterlyReportsPresignedUrlRequest = arg
    // Complete items
    // Expected Type: array
    QuarterlyReportsPresignedUrlRequest.items = QuarterlyReportsPresignedUrlRequest.items || []
    return QuarterlyReportsPresignedUrlRequest
  }
  return {
    validate: validateQuarterlyReportsPresignedUrlRequest,
    build: buildQuarterlyReportsPresignedUrlRequest
  }
})()

module.exports = QuarterlyReportsPresignedUrlRequest
